module.exports = __webpack_public_path__ + "img/YenefferOfVengerberg.0b762b6.png";